<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0 d-flex align-items-center">
                        <h5>{{ headerTitle }}</h5>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Nombre</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.name"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Titulo</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.title"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Plantilla</label>
                                    <div class="col-sm-9">
                                        <div :class="{ 'input-group': state.id }">
                                            <FileInput
                                                class="form-control"
                                                type="text"
                                                v-model="state.file"
                                                :file="state.file"
                                                :key="fileInput"
                                            />
                                            <span
                                                v-if="state.id"
                                                @click="handlerDownloadTemplate"
                                                role="button"
                                                class="input-group-text"
                                                ><i class="far fa-file-download"></i
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3 row" v-if="isReady">
                                    <label class="col-sm-3 col-form-label">Plantilla Custom</label>
                                    <div class="col-sm-9">
                                        <Treeselect
                                            v-model="state.custom"
                                            :options="templatesCustom"
                                        ></Treeselect>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-sm-9">
                                        <SelectInputSimpleState v-model="state.status" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-if="isReady">
                <DocumentDataManager v-model="state.data" />
            </div>
            <div class="col-sm-12">
                <div class="darmin card header-card">
                    <div class="row">
                        <div class="col-12 text-end">
                            <div
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('save')"
                                v-if="state.id"
                            >
                                <i class="far fa-save"></i>
                                Guardar
                            </div>
                            <div
                                v-if="!state.id"
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('new')"
                            >
                                <i class="far fa-save"></i>
                                Crear
                            </div>
                            <div
                                v-if="!state.id"
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('new_view')"
                            >
                                <i class="far fa-save"></i>
                                Crear y mostrar
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </WindowLayout>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { reactive, ref, onMounted, computed, onBeforeMount } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { useStore } from 'vuex';

// Components
import FileInput from '@/components/form/FileInput.vue';
import { useSnackbar } from 'vue3-snackbar';
import Treeselect from 'vue3-treeselect';
import WindowLayout from '@/layouts/Window.layout.vue';
import SelectInputSimpleState from '@/components/form/SelectInputSimpleState.vue';
import DocumentDataManager from '@/modules/Care/Templates/components/DocumentDataManager.vue';

// Services
import useExamenTemplate from './services/useExamenTemplate';
import useTemplatesCustom from '../Resultados/services/useTemplatesCustom';
// import useExamen from '../Examenes/services/useExamen';

export default {
    name: 'ExamenTemplateForm',
    components: {
        WindowLayout,
        SelectInputSimpleState,
        FileInput,
        DocumentDataManager,
        Treeselect
    },
    props: {
        title: { type: String, default: 'Plantilla' },
        headerTitle: { type: String, default: 'Ingresar Plantilla' },
        item: Object,
    },
    setup(props) {
        const store = useStore();
        const isReady = ref(false);
        const snackbar = useSnackbar();
        const templatesCustom = ref([]);
        // const file = ref(null);

        const state = reactive({
            id: '',
            name: '',
            title: '',
            data: [],
            file: '',
            // examen: '',
            status: 1,
            custom: '',
        });

        const fileInput = ref(Date.now());

        // const { examenes, getExamenes } = useExamen();
        const {
            examenTemplate,
            getExamenTemplate,
            createExamenTemplate,
            updateExamenTemplate,
            examenTemplates,
            downloadExamenTemplate,
        } = useExamenTemplate();

        /** ***** Autocompleters ***** */

        /** ***** Helpers ***** */
        const setState = () => {
            state.id = examenTemplate.value.id;
            state.name = examenTemplate.value.name;
            state.title = examenTemplate.value.title;
            state.data = examenTemplate.value.data;
            state.file = examenTemplate.value.file;
            // state.examen = examenTemplate.value.examen?.id;
            state.status = examenTemplate.value.status;
            state.custom = examenTemplate.value.custom;

            // examenSelected.value = examenTemplate.value.examen;
            // examenAutocomplete.value.setText(examenTemplate.value.examen?.name);
        };

        const resetWindow = () => {
            state.id = '';
            state.name = '';
            state.title = '';
            state.data = [];
            state.file = '';
            state.examen = '';
            state.status = 1;

            // examenSelected.value = null;
            // examenAutocomplete.value.setText('');
            examenTemplate.value = null;
            fileInput.value = Date.now();
        };

        /** ***** Lifecycle Hooks ***** */
        onBeforeMount(async () => {
            templatesCustom.value = (useTemplatesCustom()).getSelect();
        });
        onMounted(async () => {
            if (props.item) {
                await Promise.all([getExamenTemplate(props.item.id)]);
                if (examenTemplate.value) {
                    setState();
                }
            }
            isReady.value = true;
        });

        /** ***** Validator ***** */
        const rules = computed(() => ({
            title: { required },
            name: { required },
            file: { required },
            // examen: { required },
        }));
        const $v = useVuelidate(rules, state);

        const handleAction = async (action) => {
            await $v.value.$validate();
            if (!$v.value.$error) {
                // No errors
                let text;
                switch (action) {
                    case 'new':
                    case 'new_view':
                        await createExamenTemplate({
                            name: state.name,
                            title: state.title,
                            data: state.data,
                            file: state.file,
                            // examen: state.examen,
                            status: state.status,
                        });
                        if (action === 'new_view') {
                            store.dispatch('ContentManager/openWindow', {
                                id: `ExamenTemplateForm_${examenTemplate.value.id}`,
                                component: 'ExamenTemplateForm',
                                name: 'Plantilla',
                                params: {
                                    title: 'Plantilla',
                                    headerTitle: 'Editar Plantilla',
                                    item: { ...examenTemplate.value },
                                },
                            });
                        }
                        resetWindow();
                        text = 'Plantilla ingresado';
                        break;
                    case 'save':
                        await updateExamenTemplate(state.id, {
                            name: state.name,
                            title: state.title,
                            data: state.data,
                            file: state.file,
                            // examen: state.examen,
                            status: state.status,
                        });
                        setState();
                        text = 'Plantilla actualizado';
                        break;
                    default:
                        break;
                }
                snackbar.add({
                    type: 'success',
                    text,
                });
            } else {
                console.log($v.value.$errors);
            }
        };

        const handlerDownloadTemplate = async () => {
            const response = await downloadExamenTemplate(state.id);
            const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = state.name;
            link.click();
            URL.revokeObjectURL(link.href);
        };

        return {
            isReady,
            state,
            fileInput,
            /** Autocompleters */
            /** Actions */
            handleAction,
            examenTemplates,
            handlerDownloadTemplate,
            templatesCustom,
        };
    },
};
</script>

<style scoped></style>
